export class FetchHostURL {

  static local_key = 'host'
  static local_port = 'port'

  host_url = ''
  port_val = ''
  socketHostURL = ''
  deviceHostURL = ''


  constructor(host_url, port_val) {
    if (typeof FetchHostURL.instance === 'object') {
      return FetchHostURL.instance
    }
    this.initDefaultHoseURL(host_url, port_val)
    FetchHostURL.instance = this
    return this
  }


  initDefaultHoseURL(host, port) {
    this.host_url = window.localStorage.getItem(FetchHostURL.local_key) || host
    this.port_val = window.localStorage.getItem(FetchHostURL.local_port) || port
    this.socketHostURL = `ws://${this.host_url}:${this.port_val}/api/front`
    this.deviceHostURL = `http://${this.host_url}:${this.port_val}/api/`
  }

  setLocalHostURL(host, port) {
    window.localStorage.setItem(FetchHostURL.local_key, host)
    window.localStorage.setItem(FetchHostURL.local_port, port)
    this.initDefaultHoseURL(host, port)
  }

}
